import React, { useState } from "react";
import { signInWithEmailAndPassword, signInWithPopup } from "firebase/auth";
import { auth, googleProvider, db } from "../firebase"; // Import db
import { ref, get, set } from "firebase/database"; // Import set untuk memperbarui status login
import { Link, useNavigate } from "react-router-dom";
import { FaGoogle } from "react-icons/fa";
import { toast } from "react-toastify";

const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();

    // Fungsi untuk menyimpan atau memperbarui status login pengguna di database
    const saveUserToDatabase = async (user, isLoggedIn) => {
        const userRef = ref(db, `users/${user.uid}`); // Referensi lokasi di database

        try {
            // Ambil data pengguna yang ada di database
            const snapshot = await get(userRef);

            // Ambil saldo dari database jika sudah ada, atau default ke 0
            const existingData = snapshot.exists() ? snapshot.val() : {};
            const saldo = existingData.saldo || 0;

            // Simpan atau perbarui data pengguna di database
            await set(userRef, {
                email: user.email,
                isLoggedIn: isLoggedIn,
                saldo: saldo, // Pastikan saldo tidak undefined
                uid: user.uid
            });
        } catch (error) {
            console.error("Error saving user data to database:", error);
        }
    };

    // Fungsi login dengan email dan password
    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const userCredential = await signInWithEmailAndPassword(
                auth,
                email,
                password
            );
            const user = userCredential.user;

            // Simpan status login ke database
            saveUserToDatabase(user, true); // isLoggedIn = true

            // Navigasi berdasarkan email
            if (user.email === "padild940@gmail.com") {
                toast.success("Login Admin berhasil!");
                navigate("/admin");
            } else {
                toast.success("Login berhasil!");
                navigate("/");
            }
        } catch (error) {
            setError(error.message);
        }
    };

    // Fungsi login dengan Google
    const handleGoogleLogin = async () => {
        try {
            const result = await signInWithPopup(auth, googleProvider);
            const user = result.user;

            // Simpan status login ke database
            saveUserToDatabase(user, true); // isLoggedIn = true

            // Navigasi berdasarkan email
            if (user.email === "padild940@gmail.com") {
                toast.success("Login Admin berhasil!");
                navigate("/admin");
            } else {
                toast.success("Login berhasil!");
                navigate("/");
            }
        } catch (error) {
            setError(error.message);
        }
    };

    return (
        <div className="flex justify-center items-center min-h-screen bg-gray-100">
            <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md m-10">
                <h2 className="text-3xl font-semibold text-center mb-6">
                    Login
                </h2>
                <form onSubmit={handleLogin} className="space-y-4">
                    <label
                        className="input input-bordered flex items-center gap-2"
                        htmlFor="email"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 16 16"
                            fill="currentColor"
                            className="h-4 w-4 opacity-70"
                        >
                            <path d="M2.5 3A1.5 1.5 0 0 0 1 4.5v.793c.026.009.051.02.076.032L7.674 8.51c.206.1.446.1.652 0l6.598-3.185A.755.755 0 0 1 15 5.293V4.5A1.5 1.5 0 0 0 13.5 3h-11Z" />
                            <path d="M15 6.954 8.978 9.86a2.25 2.25 0 0 1-1.956 0L1 6.954V11.5A1.5 1.5 0 0 0 2.5 13h11a1.5 1.5 0 0 0 1.5-1.5V6.954Z" />
                        </svg>
                        <input
                            type="email"
                            id="email"
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="email"
                            className="grow"
                            required
                        />
                    </label>
                    <label
                        className="input input-bordered flex items-center gap-2"
                        htmlFor="password"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 16 16"
                            fill="currentColor"
                            className="h-4 w-4 opacity-70"
                        >
                            <path
                                fillRule="evenodd"
                                d="M14 6a4 4 0 0 1-4.899 3.899l-1.955 1.955a.5.5 0 0 1-.353.146H5v1.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2.293a.5.5 0 0 1 .146-.353l3.955-3.955A4 4 0 1 1 14 6Zm-4-2a.75.75 0 0 0 0 1.5.5.5 0 0 1 .5.5.75.75 0 0 0 1.5 0 2 2 0 0 0-2-2Z"
                                clipRule="evenodd"
                            />
                        </svg>
                        <input
                            type="password"
                            id="password"
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="password"
                            className="grow"
                            required
                        />
                    </label>
                    {error && <p className="text-red-500 text-sm">{error}</p>}
                    <button
                        type="submit"
                        className="w-full py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition duration-300"
                    >
                        Login
                    </button>
                </form>
                <div className="flex items-center justify-between mt-6">
                    <hr className="flex-grow border-t border-gray-300" />
                    <span className="mx-4 text-gray-500">or</span>
                    <hr className="flex-grow border-t border-gray-300" />
                </div>
                <button
                    onClick={handleGoogleLogin}
                    className="w-full mt-6 py-3 bg-red-600 text-white rounded-lg flex items-center justify-center gap-2 hover:bg-red-700 transition duration-300"
                >
                    <FaGoogle />
                    Login with Google
                </button>

                <div className="mt-4 text-center">
                    <span className="text-gray-600">Belum punya akun? </span>
                    <Link
                        to="/register"
                        className="text-blue-600 hover:underline"
                    >
                        Daftar di sini
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default Login;
